import { Observable } from 'rxjs/Rx'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import * as authenticationDuck from 'store/ducks/authentication'
import { combineEpics } from 'redux-observable'
import { GlobalState } from './state'
import { Hub } from 'interfaces/hub'
import { HubParams, getHub } from 'store/services/hub'

export type HubState = {
  hubs: { [key: Hub['id']]: Hub }
  isLoading: boolean
}

const INITIAL_STATE: HubState = {
  hubs: {},
  isLoading: false,
}

type HubReducer<A = undefined> = (state: HubState, action?: PayloadAction<A>) => void

const hubSlice = createSlice({
  name: 'hubs',
  initialState: INITIAL_STATE,
  reducers: {
    fetchHub: ((state) => {
      state.isLoading = true
    }) as HubReducer<HubParams>,
    fetchHubSuccess: ((state, action) => {
      state.hubs = { ...state.hubs, [action.payload.id]: action.payload }
      state.isLoading = false
    }) as HubReducer<Hub>,
    fetchHubFailure: ((state) => {
      state.isLoading = false
    }) as HubReducer,
  },
})

export const { fetchHub, fetchHubSuccess, fetchHubFailure } = hubSlice.actions

export const reducer = hubSlice.reducer

export const epic = combineEpics(hubRequestEpic)

export function hubRequestEpic(action$) {
  return action$.ofType(fetchHub.type).mergeMap((action) => {
    return (
      Observable.ajax(getHub(action.payload))
        .mergeMap((res) => Observable.of(fetchHubSuccess(res.response)))
        // @ts-ignore
        .catch((err) => {
          if (typeof err === 'object' && (err.response || {}).code === 401) {
            return Observable.of(authenticationDuck.refreshTokenRequest(action))
          }

          return Observable.of(fetchHubFailure())
        })
    )
  })
}

export const selectHubs = (state: GlobalState) => state.hubs
